import templateUrl from "emun.salesrep/pastdue-invoices.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import resolve from "ioc/resolve";
import emailInvoicePrompt from "emun.invoice/email-invoice-prompt";
import PrintInvoiceOptions from "emun.invoice/invoice-print";
import ServiceBus from "servicestack/service-bus";

class PastDueInvoiesController {
	constructor($rootScope) {
		const $ctrl = this;
		basicController($ctrl);

		var context = $ctrl.context || "rep";
		var repFilter = "";
		if (context === "customer") {
			repFilter = "&RetailerId=" + $ctrl.customer.id;
		} else if (context === "manager") {
			repFilter = "&ManagerId=" + $ctrl.rep.id;
		} else if (context === "executive") {
		} else if (context === "rep") {
			repFilter = "&SalesRepID=" + $ctrl.rep.id;
		}

		//var filter = "SalesRepID";
		//if (context == 'manager') { filter = "ManagerId";}

		$ctrl.query = new AutoQuery({
			url: "QueryInvoices.json?DaysPastDueGreaterThan=0" + repFilter,
			fields:
				"Id,InvoiceDate,Status,SalesRepId,TransactionType,PONumber,OrderNumber,RetailerId,Custom1,CompanyName,Division,InvoiceTotal,TotalFreight,TotalShipped,InvoiceBalance",
			orderBy: "-InvoiceDate",
			autoLoad: true,
			pageSize: 10,
			scrollTop: false
		});
	}
	printInvoice(invoice) {
		const $ctrl = this;
		return PrintInvoiceOptions({
			request: {
				id: invoice,
				IncludeImages: false,
				IncludeBarcodes: false,
				OrderBy: "strProductID"
			}
		});
	}
	emailInvoice(invoice) {
		//emailInvoicePrompt(options);
		const $ctrl = this;
		return emailInvoicePrompt({
			id: invoice,
			invoiceNumber: invoice,
			IncludeImages: false,
			IncludeBarcodes: false,
			OrderBy: "strProductID"
		});
	}
}

let PastDueInvoies = {
	bindings: {
		repId: "@",
		context: "@",
		rep: "<",
		customer: "<"
	},
	controller: PastDueInvoiesController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default PastDueInvoies;
